<template>
  <div class="edit-studio-container">

    <main class="tab-content">

      <h2 class="item text-secondary">Company form content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Country code:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.country_code" />
        </div>
        <div class="field-sec">
          <label>Title:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_form_title" />
        </div>
        <div class="field-sec">
          <label>Subtitle:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_form_sub_title" />
        </div>
        <div class="field-sec">
          <label>First name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_first_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Last name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_last_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Company name placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_com_name_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Job title placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_job_title_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Email placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_email_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Phone placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_phone_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Message placeholder:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.kmt_msg_placeholder" />
        </div>
        <div class="field-sec">
          <label class="">Submit button:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.send_btn_text" />
        </div>
        <div class="field-sec">
          <label class="">Thank you page:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.thank_you_page" />
        </div>
      </form>
      <h2 class="item text-secondary">Error messages:</h2>
      <form class="form-container admin-studio-tab-pane fade show active" id="error">
        <div class="field-sec">
          <label class="">First name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_first" />
        </div>
        <div class="field-sec">
          <label class="">Last name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_last" />
        </div>
        <div class="field-sec">
          <label class="">First & Last name error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_first_last" />
        </div>
        <div class="field-sec">
          <label class="">Email error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_email" />
        </div>
        <div class="field-sec">
          <label class="">Invalid email error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_email2" />
        </div>
        <div class="field-sec">
          <label class="">Phone error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_phone" />
        </div>
        <div class="field-sec">
          <label class="">Invalid phone error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_phone2" />
        </div>
        <div class="field-sec">
          <label class="">Message error:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.err_des" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>

  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';



export default {
  name: 'CompanyForm',
  components: {

  },
  props: ["selectTab", "admin_fit20", "fit20", "admin", "saveBlock"],
  data() {
    return {
    };
  },
  methods: {
    isValidEmail: function (email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    },

    cancelEditing: function () {
      if (!isEqual(this.fit20.blockToEdit, this.fit20.originalBlock)) {
        this.fit20.blockToEdit = {
          ...this.fit20.originalBlock
        };
        this.updated = true;
      }
    },
  },
  watch: {
    "fit20.blockToEdit": {
      deep: true, // Watch for changes in nested properties
      handler(newVal) {

        if (isEqual(newVal, this.fit20.originalBlock)) {
          $('#cancelUser').removeClass("cancel-btn-active");
          $('#saveUser').removeClass("save-btn-active");
          $('#cancelUser2').removeClass("cancel-btn-active");
          $('#saveUser2').removeClass("save-btn-active");
        } else {
          if (!$('#cancelUser').hasClass('cancel-btn-active')) {
            $('#cancelUser').addClass("cancel-btn-active");
            $('#saveUser').addClass("save-btn-active");
            $('#cancelUser2').addClass("cancel-btn-active");
            $('#saveUser2').addClass("save-btn-active");
          }
        }
      }
    },
  }
};
</script>

<style>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.edit-studio-container .tab-content {
  padding-top: 15px;
}

.edit-studio-container .tab-content h2 {
  margin-left: 10px;
}

.edit-studio-container .img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.edit-studio-container .admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.edit-studio-container .form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-container .form-container div {
  width: calc(100% / 2 - 30px);
}

.edit-studio-container .form-container label {
  display: block;
}

.edit-studio-container .studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.edit-studio-container .users-col {
  width: calc(100%);
}

.edit-studio-container .studio-machines {
  width: 100%;
}

.edit-studio-container .ex-member-container {
  margin-top: 10px;
}

.edit-studio-container .ex-member-flex {
  width: 100% !important;
}

.edit-studio-container .ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.edit-studio-container .ex-member-container img {
  margin-bottom: 7px;

}

.edit-studio-container .measure-div {
  position: relative;
}

.edit-studio-container .kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}
</style>
